var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-toolbar',{staticClass:"white--text",attrs:{"dense":"","dark":"","color":"secondary"}},[_c('v-spacer'),_c('v-toolbar-title',[_vm._v(" New Tracking ")]),_c('v-spacer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }